import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax
import styled from "styled-components";
import React, { useRef, useEffect } from 'react';
import useViewerStore from '../../store-zustand/viewer';

mapboxgl.accessToken = 'pk.eyJ1IjoiZmFzdG1hcCIsImEiOiJja2N4Y3FodWswNmVzMnJudnRwZW8yY3huIn0.vRWDQDzqfwaEFquoc5SF3g';

const Wrapper = styled.div`
    @media (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
        display: none;
    }
    .mapboxgl-ctrl-attrib.mapboxgl-compact {
        margin: -41px;
    }
`;

const Mapboxmodal = () => {
    const { currentBBOX, mapbox, mapboxvisibility, setMapbox, SearchWeatherData: RequestWeatherData } = useViewerStore();
    const mapContainer = useRef(null);
    const map = useRef(null);

    useEffect(() => {
        if (map.current) return;

        map.current = new mapboxgl.Map({
            container: mapContainer.current,
            style: 'mapbox://styles/fastmap/ckr5sap791cqc17mxrk7kz103',
        });
        setMapbox(map.current);
    });

    useEffect(() => {
        let isMounted = true;

        (async () => {
            const rect = currentBBOX;
            if (currentBBOX !== undefined) {
                if (mapbox !== undefined && rect !== undefined) {
                    if (rect[0] === "-180.0000" && rect[1] === "180.0000") {
                        mapbox.flyTo({ center: [45.249753, -76.360733] });
                    } else {
                        mapbox.fitBounds([[rect[0], rect[2]], [rect[1], rect[3]]], { duration: 1000 });
                    }
                }
            }
            if (!isMounted) return;
        })();

        return () => {
            isMounted = false;
        };
    }, [currentBBOX]);

    const map_style = {
        height: '182px',
        width: '322px',
        pointerEvents: 'none',
        position: 'fixed',
        top: '3rem',
        right: '3rem',
        zIndex: 0,
        opacity: mapboxvisibility
    }
    
    return (
        <Wrapper>
            <div style={map_style} ref={mapContainer} className="map-container" />
        </Wrapper>
    )
};

export default Mapboxmodal;